angular
	.module('components.planodiretor')
	.factory('PlanoDiretorService', PlanoDiretorService);

PlanoDiretorService.$inject = ['$http', 'URL_REST'];

function PlanoDiretorService($http, URL_REST) {

	function buscarLogradourosPorLote(schema, valor, cidade) {
		return $http.get(URL_REST + 'clicklote/' + schema + '/id_gpx_lot/' + valor + '/' + cidade);
	}

	function buscarClientes() {
		// DEPRECIADO
		return $http.get(URL_REST + 'schema/public/tabela/clientes');
	}

	function buscarCliente(slug) {
		return $http({
			method: "POST",
			url: URL_REST + 'inicio-pd-cliente',
			data: JSON.stringify({clien_slug: slug}),
			headers: {
				'Content-Type': 'text/plain'
			}
		});
	}

	function buscarSchemaTabelaColunaValor(schema, tabela, coluna, valor) {
		return $http.get(URL_REST + 'schema/' + schema + '/tabela/' + tabela + '/busca/' + coluna + '/' + valor);
	}

	function buscarDados(id_client, schema, tabela) {
		// return $http.get(URL_REST + 'schema/' + schema + '/tabela/' + tabela);
		return $http.get(URL_REST + 'pdlayergrupo/' + id_client);
	}

	function gerarPDF1() {
		return $http.get('http://localhost/geocontrole/api/Planodiretor/pdf');
	}

	function buscarUsoSolo(dados) {
		return $http({
			method: "POST",
			url: URL_REST + 'usosolo',
			data: JSON.stringify(dados),
			headers: {
				'Content-Type': 'text/plain'
			},
		});
	}

	function gerarPDF(dados) {
		// dados = [];
		return $http({
			method: "POST",
			// url: URL_REST + 'gerapdf',
			url: URL_REST + 'docfinal',
			data: JSON.stringify(dados),
			headers: {
				'Content-Type': 'text/plain'
			},
		});
	}
	function gerarNoBrowser(dados) {
		// dados = [];
		return $http({
			method: "POST",
			// url: URL_REST + 'gerapdf',
			url: URL_REST + 'docfinalBrowser',
			data: JSON.stringify(dados),
			headers: {
				'Content-Type': 'text/plain'
			},
		});
	}

	function aplicarFiltro(obj) {
		return $http({
			method: "POST",
			url: URL_REST + 'busca-plano-diretor',
			data: JSON.stringify(obj),
			headers: {
				'Content-Type': 'text/plain'
			},
		});
	}

	return {
		buscarLogradourosPorLote: buscarLogradourosPorLote,
		buscarClientes: buscarClientes,
		buscarSchemaTabelaColunaValor: buscarSchemaTabelaColunaValor,
		buscarDados: buscarDados,
		buscarUsoSolo: buscarUsoSolo,
		gerarPDF: gerarPDF,
		gerarNoBrowser: gerarNoBrowser,
		aplicarFiltro: aplicarFiltro,
		buscarCliente: buscarCliente
	};
}
